var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMailOutlineWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 32,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "#fff",
  strokeWidth: 1.5,
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.917 6.083h25.167v19.833H3.917z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.833 6.667 16.5 15.333l12-8.666"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M.5 0h32v32H.5z"
})))));
export { SvgMailOutlineWhite as ReactComponent };
export default "/_next/static/images/mail-outline-white.svg";